import LettersInput from './LetterInputs';

export default LettersInput;